/**
 * Mortgage API Configuration
 * Switch between mock and production by setting VITE_MORTGAGE_USE_MOCK=false
 * and providing VITE_MORTGAGE_API_BASE_URL when professor's backend is ready.
 */

export const MORTGAGE_API_CONFIG = {
  // Set to false and provide BASE_URL when professor's backend is ready
  USE_MOCK: import.meta.env?.VITE_MORTGAGE_USE_MOCK !== 'false',BASE_URL: import.meta.env?.VITE_MORTGAGE_API_BASE_URL || 'https://api.professor-mortgage-backend.com/v1',

  TIMEOUT_MS: parseInt(import.meta.env?.VITE_MORTGAGE_TIMEOUT_MS) || 15000,

  MAX_RETRIES: 3,

  RETRY_DELAY_MS: 1000,

  // Auth token storage key
  TOKEN_KEY: 'mortgage_auth_token',REFRESH_TOKEN_KEY: 'mortgage_refresh_token',

  // Endpoints — update paths to match professor's actual routes
  ENDPOINTS: {
    // Authentication
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      PROFILE: '/auth/profile',
    },
    // Mortgage calculations
    MORTGAGE: {
      ELIGIBILITY_CHECK: '/mortgage/eligibility',
      PAYMENT_CALCULATOR: '/mortgage/calculate-payment',
      APPROVAL_PROCESS: '/mortgage/apply',
      REFINANCE_ANALYSIS: '/mortgage/refinance',
      RATE_COMPARISON: '/mortgage/rates',
      AFFORDABILITY: '/mortgage/affordability',
    },
    // Utility
    UTILITY: {
      HEALTH_CHECK: '/health',
      LENDERS: '/utility/lenders',
      INTEREST_RATES: '/utility/interest-rates',
    },
  },
};

export default MORTGAGE_API_CONFIG;
